module.exports = __webpack_public_path__ + "img/poster_tem_3.f5ae77bb.png";